/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHiddenGrid = (props: Props) => (
  <Icon viewBox="0 0 23 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h5v5H2zm0 7h5v5H2zm7 10.034V21h1.72A8.778 8.778 0 0 1 9 19.034zm12-5.046V9h-5v3.003c1.245.043 3.295.513 5 1.985zM18 11h1v1h-1zm-4 .92V9h-3.273zM2 16h5v5H2zM9 2h5v5H9zm12 0h-5v5h5zm-3.127 18.629 3.55 3.134 1.238-1.526-3.064-2.705a7.164 7.164 0 0 0 1.37-1.617l.239-.402-.224-.41C19.627 14.634 17.027 14 15.812 14c-.735 0-1.41.166-2.008.416l-3.602-3.18-1.238 1.527 3.1 2.737a7.304 7.304 0 0 0-1.391 1.554l-.283.442.283.441c1.517 2.37 3.91 3.04 5.1 3.054a4.68 4.68 0 0 0 2.1-.362zm.235-2.412-.859-.758c-.02-.81-.656-1.459-1.436-1.459a1.39 1.39 0 0 0-.2.014l-.858-.758A2.305 2.305 0 0 1 15.813 15c1.323 0 2.395 1.12 2.395 2.5 0 .25-.035.49-.1.717zm-2.096.769.858.758a2.306 2.306 0 0 1-1.058.256c-1.323 0-2.395-1.12-2.395-2.5 0-.25.035-.49.1-.717l.859.758c.02.81.656 1.459 1.437 1.459.067 0 .133-.005.199-.014z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHiddenGrid as HiddenGrid };
